import React from "react";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
// Import banner image
import bannerImage from "../../assets/img/signin-bg1.webp";

const useStyles = makeStyles({
  bannerContainer: {
    position: "relative",
    width: "100%",
    height: "400px",
    // Use the imported image directly in the CSS
    backgroundImage: `url(${bannerImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
  },
  bannerContent: {
    position: "relative",
    zIndex: 2,
    padding: "0 10%",
    width: "100%",
  },
  bannerTitle: {
    color: "white",
    fontSize: "48px",
    fontWeight: "bold",
    margin: 0,
  },
});

const Banner = ({ title }) => {
  const classes = useStyles();

  return (
    <div className={classes.bannerContainer}>
      <div className={classes.bannerContent}>
        <h1 className={classes.bannerTitle}>{title}</h1>
      </div>
    </div>
  );
};

Banner.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Banner;
